export default __webpack_public_path__ + "static/media/TikTok_ForYou_Final.e5657f8a.jpeg";